<ng-template [ngIf]="isAssegnandoOda">
  <app-loading></app-loading>
</ng-template>
   <div class="d-flex mt-2">
    <form [formGroup]="assegnaOdaForm">    
    <div class="grid formgrid p-fluid">
            
          <div class="field mt-2 mb-2 col-12">
            <p-dropdown inputId="oda" [options]="listaOda" optionLabel="numero" [showClear]="true"
                  placeholder="Ordini di acquisto disponibili" formControlName="oda"
                  >
                  <ng-template let-oda pTemplate="item">
                      <p-tag
                          [value]="oda.numero"
                          [style]="{
                          'background-color': '#326F6F' ,
                          'color': '#ffffff' ,
                          'border-radius': '6px',
                          'padding': '.25em .5rem',
                          'font-weight': '700',
                          'font-size': '13px',
                          'letter-spacing': '.3px;',
                          'cursor': 'pointer',
                          }"
                      ></p-tag>
                  </ng-template>
              </p-dropdown>
          </div>
          </div>
          </form>
   </div>

    <div class="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
    <div class="margin-top-1" style="text-align: center; display: flex; justify-content: center; align-items: center;">
      <p-button icon="pi pi-times" (onClick)="conferma(false)" label="Annulla" class="p-button-text mr-2"
      styleClass="p-button-warning"></p-button>
     <p-button  icon="pi pi-check" label="Conferma"
      class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="isAssegnandoOda || !assegnaOdaForm.valid"></p-button>
  </div>
